export default __webpack_public_path__ + "static/media/CRM-3.2fbdbe4f.png";